import { getRisks, GetRisksPayloadType } from '@api/risk'
import { ListRisk } from '@views/risk'
import { mutationKeys } from '@definitions/react-query-mutation-keys'
import { useRequestParams } from '@hooks/useRequestParams'
import { RiskType } from '@pages/types'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { riskMapperApi } from '@/mappers'

const RisksPage = () => {
  const { afterPageChange, setParams, reqParams, pagination, onTableStateChange } =
    useRequestParams<GetRisksPayloadType, RiskType>()

  const { data: risksApi = [], dataUpdatedAt } = useQuery({
    queryKey: mutationKeys.risks(reqParams),
    queryFn: () => getRisks(reqParams),
  })

  const risks = risksApi.filter((risk) => risk.state !== 99).map(riskMapperApi)

  useEffect(() => {
    afterPageChange(risksApi.length)
  }, [dataUpdatedAt])

  return (
    <ListRisk
      risks={risks}
      onFiltersChange={setParams}
      tableProps={{ pagination, onChange: onTableStateChange }}
    />
  )
}

export default RisksPage
